var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.IS_STAGE)?_c('div',{staticClass:"environment-banner d-flex align-center justify-center"},[_c('span',{staticClass:"mr-2"},[_vm._v("stage")]),_vm._v(" "),_c('v-img',{attrs:{"src":"/graphics/medtyan.png","alt":"","max-width":"16"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }